import { z } from 'zod';
import {
  EBopisSettingsEarliestPickupDay,
  EBopisSettingsPickupBy,
  EBopisSettingsPickupSlotDuration,
  EBopisSettingsUsuallyReadyIn,
} from './common';

const CustomerNotificationSchema = z.object({
  orderPlaced: z.boolean().optional(),
  orderReadyForPickup: z.boolean().optional(),
  packingDelayed: z.boolean().optional(),
  pickupMissed: z.boolean().optional(),
  packingDelayedFirstNotification: z.string().optional(),
  pickupMissedFirstNotificationAfter: z.string().optional(),
  pickupMissedSecondNotificationAfter: z.string().optional(),
  orderCancelled: z.boolean().optional(),
  orderPickedUp: z.boolean().optional(),
});

export const PackingDelayedFirstNotificationEnum = z.enum([
  '15 mins',
  '30 mins',
  '1 hr',
  '2 hrs',
  '3 hrs',
  '4 hrs',
]);
export type PackingDelayedFirstNotificationEnum = z.infer<
  typeof PackingDelayedFirstNotificationEnum
>;

const StoreNotificationSchema = z.object({
  orderPlaced: z.boolean().optional(),
  packingDelayed: z.boolean().optional(),
  packingDelayedFirstNotification: PackingDelayedFirstNotificationEnum.optional(),
  packingDelayedSecondNotification: z.string().optional(),
  pickupMissed: z.boolean().optional(),
  pickupMissedFirstNotificationAfter: z.string().optional(),
  pickupMissedSecondNotificationAfter: z.string().optional(),
  orderCancelled: z.boolean().optional(),
});

const NotificationSchema = z.object({
  customer: CustomerNotificationSchema,
  store: StoreNotificationSchema,
});

const CompanySettingsSchema = z.object({
  bopisStatus: z.union([z.literal('active'), z.literal('inactive')]),
  bopisBeginDate: z.string(),
  bopisEndDate: z.string(),
  pickupBy: EBopisSettingsPickupBy,
  earliestPickupDay: EBopisSettingsEarliestPickupDay,
  earliestPickupTime: z.string(),
  pickupSlotDuration: EBopisSettingsPickupSlotDuration,
  usuallyReadyIn: EBopisSettingsUsuallyReadyIn,
  markInventoryLowBelow: z.number(),
  makeItemUnavailableWhenInventoryBelow: z.number(),
  minOrderValue: z.number(),
  maxOrderValue: z.number().optional(),
  minCustomerAge: z.number(),
  notification: NotificationSchema,
  _id: z.string(),
});

export type IMongodbCompany = z.infer<typeof CompanySettingsSchema>;
